// // components/common/Notification.js
// import { notification as AdNotification } from "antd"

// const [api, contextHolder] = AdNotification.useNotification()

// const openNotification = ({
//   showProgress = true,
//   title,
//   icon,
//   duration = 4,
//   description,
//   type = "success",
//   placement = "topRight",
//   pauseOnHover = true,
//   closeIcon = true,
//   className,
//   role = "Alert",
// }) => {
//   api.open({
//     message: title,
//     closeIcon,
//     className,
//     description,
//     icon,
//     placement,
//     type,
//     duration,
//     pauseOnHover,
//     showProgress,
//     role,
//   })
// }

// export { openNotification, contextHolder }

// ============================================

// components/common/NotificationProvider.js
import React, { createContext, useContext } from "react"
import { notification as AdNotification } from "antd"

const NotificationContext = createContext(null)

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = AdNotification.useNotification()

  const openNotification = ({
    showProgress = true,
    title,
    icon,
    duration = 5,
    description,
    type = "success",
    placement = "topRight",
    pauseOnHover = true,
    closeIcon,
    className,
    role = "Alert",
  }) => {
    api.open({
      message: title,
      closeIcon,
      className,
      description,
      icon,
      placement,
      type,
      duration,
      pauseOnHover,
      showProgress,
      role,
    })
  }

  return (
    <NotificationContext.Provider value={openNotification}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  )
}

export const useNotification = () => useContext(NotificationContext)
